import config from "config/config";
import HandleApiResponse from "utils/handleApiResponse";

const commonAPI = () => {
  const { handleResponse, handleError } = HandleApiResponse();

  async function getBackgroundProcessLogsAPI(values) {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "User-Timezone": userTimeZone
        },
      };
      const query = JSON.stringify(values);
      const res = await fetch(
        `${config.host}/panel/common/background-process-logs?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  return {
    getBackgroundProcessLogsAPI,
  };
};
export default commonAPI;
